import React from 'react';
import { bool, func } from 'prop-types';

import { ACTIVITY_TYPES } from '../../../../../constants';
import ActivityWrapper from '../activity-wrapper';
import NoteSection from '../note-section';
import problemActivityShape from '../../../../../shapes/problem-activity';
import { formatUsername } from '../../../../../utils/common';

/**
 * Problem Logged Activity Component
 * @param {object} params - object containing props
 * @param {object} activity - Activity data to display
 * @param {boolean} errorBackground - Boolean specifying if this card should show as error
 * @param {func} scrollTo - Handles scrolling to this activity in the parent
 * @param {boolean} hideComments - Specifies if the comments button should be hidden
 * @return {element}
 */
const ActivityLogProblem = ({
  activity,
  errorBackground,
  scrollTo,
  hideComments,
}) => {
  const problemInfo = { text: `${formatUsername(activity.initiatorName)} logged a problem`, descriptor: activity.problem };
  const lumperFee = activity.reimbursementFee ? { text: 'Lumper Fee', descriptor: `$${activity.reimbursementFee}` } : null;
  return (
    <ActivityWrapper
      type={ACTIVITY_TYPES.logProblem}
      headerContent={[problemInfo, lumperFee]}
      backgroundWarn={errorBackground}
      timestamp={activity.eventTime}
      testId="activity-problem-set"
      eventId={activity.eventId}
      activity={{ ...activity }} // TODO: Remove once real comments come back from API
      scrollTo={scrollTo}
      canComment={!hideComments}
      descriptorWarn
    >
      <NoteSection note={activity.note} />
    </ActivityWrapper>
  );
};

ActivityLogProblem.propTypes = {
  activity: problemActivityShape.isRequired,
  errorBackground: bool,
  scrollTo: func,
  hideComments: bool,
};

ActivityLogProblem.defaultProps = {
  errorBackground: false,
  scrollTo: () => { },
  hideComments: false,
};

export default ActivityLogProblem;
